const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA;

export {
  // eslint-disable-next-line import/prefer-default-export
  RECAPTCHA_KEY,
};
